<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
    Header(:content="headerContent")
    ModalWindow(
      @closeModal="() => { this.showModalWindow = false }"
      :modalContentId="modalContentId"
      :showModal="showModalWindow")
    div.wrap-trainer-user.f.fh
      ModuleUser(
        v-if="user"
        :user="user"
        @showModal="showModal")
</template>

<style lang="scss" scoped>
.wrap-trainer-user {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db, { env } from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers("auth")
import Auth from "@/components/auth"
import Header from "@/components/shared/Header.vue"
import ModalWindow from "@/components/shared/ModalWindow.vue"
import ModuleUser from "@/components/module/ModuleUser"

export default {
  components: {
    Auth,
    Header,
    ModalWindow,
    ModuleUser
  },
  data () {
    return {
      user: null,
      trainer: null,
      trainee: null,
      headerContent: {
        label: "ホーム",
        leftAction: {
          icon: "event",
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push(this.toCalendarPath)
          }
        },
        rightAction: {
          icon: "account_circle",
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push(this.toAccountPath)
          }
        }
      },
      modalContentId: "",
      showModalWindow: false,
      toCalendarPath: "",
      toAccountPath: ""
    }
  },
  computed: {
    ...mapStateAuth(["uid"]),
    env: function () {
      return env
    }
  },
  created () {
    this.toCalendarPath = (this.$route.name === "trainee-user") ? "/calendar" : "/trainer/calendar"
    this.toAccountPath = (this.$route.name === "trainee-user") ? `/trainee/${this.uid}` : `/trainer/${this.uid}`
  },
  methods: {
    onFailedAuthentication () {
      this.$router.push("/sign-in")
    },
    onLoggedIn () {

      if (this.$route.name === "trainee-user") {
        db.collection("TRAINEE")
          .doc(this.uid)
          .onSnapshot(this.handleUser)
      } else if (this.$route.name === "trainer-user") {
        db.collection("TRAINER")
          .doc(this.uid)
          .onSnapshot(this.handleUser)
      }
      
    },
    handleUser (d) {
      this.user = d.data()
    },
    handleTrainee (d) {
      this.trainee = d.data()
    },
    handleTrainer (d) {
      this.trainer = d.data()
    },
    showModal (modalContentId)  {
      console.log(modalContentId)
      this.modalContentId = modalContentId
      this.showModalWindow = true
    }
  }
}
</script>
